module.exports = __webpack_public_path__ + "img/noImage.01238bca.png";